import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ theme: "dark", setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      const s = localStorage.getItem("geni_theme");
      return s === "light" ? "light" : "dark";
    } catch { return "dark"; }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    if (theme === "dark") { root.classList.add("dark"); }
    else { root.classList.remove("dark"); }
    root.style.colorScheme = theme;
    try { localStorage.setItem("geni_theme", theme); } catch {}
  }, [theme]);

  const setTheme = (t) => setThemeState(t === "light" ? "light" : "dark");
  return <ThemeCtx.Provider value={{ theme, setTheme }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
